import { Miembro } from '../lib/supabase';

export interface CamposIncompletos {
  rutPasaporte: boolean;
  email: boolean;
  telefono: boolean;
  direccion: boolean;
  fechaIngreso: boolean;
}

export const getCamposIncompletos = (miembro: Miembro): CamposIncompletos => {
  return {
    rutPasaporte: !miembro.rut_pasaporte || miembro.rut_pasaporte.trim() === '',
    email: !miembro.email || miembro.email.trim() === '',
    telefono: !miembro.telefono || miembro.telefono.trim() === '',
    direccion: !miembro.direccion || miembro.direccion.trim() === '',
    fechaIngreso: !miembro.fecha_ingreso || (typeof miembro.fecha_ingreso === 'string' && miembro.fecha_ingreso.trim() === '')
  };
};

export const tieneCamposIncompletos = (miembro: Miembro): boolean => {
  const campos = getCamposIncompletos(miembro);
  return Object.values(campos).some(incompleto => incompleto);
};

export const contarCamposIncompletos = (miembro: Miembro): number => {
  const campos = getCamposIncompletos(miembro);
  return Object.values(campos).filter(incompleto => incompleto).length;
};
